module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/review-stars-detail-6e6d747b30708d685780b00af17c7359.png";